module.exports = __webpack_public_path__ + "img/pano-west-view.6bc62615.jpg";